import { render, staticRenderFns } from "./PublipostageIcon.vue?vue&type=template&id=94e7d91c&"
import script from "./PublipostageIcon.vue?vue&type=script&lang=js&"
export * from "./PublipostageIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports